import { queryClient } from './lib/query-client';
import { getInvoice, invoiceKeys } from './features/invoices/api/services';
import { rewriteLegacyPath, routes } from './routes';

/**
 * Inicia prefetch de dados e chunks antes do React montar.
 *
 * Para a rota de detalhe de fatura (mais acessada), dispara em paralelo:
 * 1. Prefetch do chunk lazy da página
 * 2. Prefetch dos dados da API (popula o cache do React Query)
 *
 * Quando o componente monta e o useQuery dispara, os dados já estarão
 * no cache ou em trânsito — eliminando a espera sequencial.
 *
 * `rewriteLegacyPath` normaliza o alias em inglês antes do match, então links
 * já compartilhados (WhatsApp, e-mail) também aproveitam o prefetch.
 */
export function prefetchRouteData(): void {
  const path = rewriteLegacyPath(window.location.pathname);
  const prefix = `${routes.invoiceList}/`;
  if (!path.startsWith(prefix)) {
    return;
  }
  const invoiceId = path.slice(prefix.length);
  if (!invoiceId || invoiceId.includes('/')) {
    return;
  }

  // Prefetch do chunk da página (dispara download em paralelo)
  import('./features/invoices/invoice').catch((e) => {
    if (import.meta.env.DEV) {
      console.warn('[Prefetch] Chunk load failed:', e);
    }
  });

  // Prefetch dos dados da API — popula o cache do React Query
  queryClient.prefetchQuery({
    queryKey: invoiceKeys.detail(invoiceId),
    queryFn: () => getInvoice(invoiceId),
  });
}
